import type { TenantStatus } from '@naya/shared'

const LABELS: Record<TenantStatus, string> = {
  pending_setup: 'Pending setup',
  active: 'Active',
  suspended: 'Suspended',
}

export function StatusPill({ status }: { status: TenantStatus }) {
  return (
    <span className={`admin-pill admin-pill-${status}`}>{LABELS[status]}</span>
  )
}
